import orderBy from 'lodash/orderBy';

import helpers from '../helpers';
import mapKeys from 'lodash/mapKeys';

export default {

  state: {
    serviceAreas: [],
    providers: [],
  },

  getters: {

    serviceAreas(state) {
      return orderBy(state.serviceAreas, ['properties.Location'], ['asc']);
    },

    servicesById: (state) => (id) => {
      return state.serviceAreas.filter(({ properties }) => properties.ProviderID === id);
    },

    providers(state) {
      return state.providers;
    },

  },

  mutations: {

    SET_SERVICE_AREAS(state, payload) {
      state.serviceAreas = payload;
    },

    SET_PROVIDERS(state, payload) {
      state.providers = payload;
    },

  },

  actions: {

    async getServiceAreas({ commit, getters }) {
      commit('LOADING_SERVICE_AREAS', true);

      if (getters.serviceAreas && getters.serviceAreas.length) {
        console.warn('Already loaded service areas but refreshing.');
      }

      const serviceAreas = await helpers.requests.requestServiceAreas();

      if (serviceAreas && serviceAreas.length) {
        console.warn('Refreshed service areas.');
        const serviceAreasRekeyed = serviceAreas.map((serviceArea) => ({
          ...serviceArea,
          properties: mapKeys(serviceArea.properties, (value, key) => key
            .replace('Publication.DBO.CommunicationProjects.', '')
            .replace('Publication.DBO.CommunicationProviders.', '')
          )
        }));

        commit('SET_SERVICE_AREAS', serviceAreasRekeyed);
        return serviceAreasRekeyed;
      }
      commit('LOADING_SERVICE_AREAS', false);
    },

    async getProviders({ commit, getters }) {
      if (getters.providers.length) {
        console.warn('Phew! we already had providers loaded!');
      }

      const providers = await helpers.requests.getProviders();
      if (providers) {
        console.warn('Refreshed providers.');
        commit('SET_PROVIDERS', providers);
      }
      return providers;
    },

  },

};
